import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled, Typography } from '@mui/material';

export const ContactsContainerStyled = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const ContactsStyled = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 'bold',
  textTransform: 'uppercase',
  color: theme.palette.colors.onFooterBackground,
  marginBottom: '16px',

  [theme.breakpoints.up('sm')]: {
    marginBottom: '20px',
  },
}));

export const ContactsListListed = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '220px',

  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '500px',
    maxWidth: 'none',
  },
}));

export const TypographyStyled = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.colors.onFooterBackground,
}));

export const FontAwesomeIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.colors.iconsOnFooterBackground,
  fontSize: 16,
  marginRight: 8,
}));

export const InfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  textDecoration: 'none',

  '&:not(:last-child)': {
    marginBottom: '16px',
  },

  [theme.breakpoints.up('lg')]: {
    width: '182px',

    '&:nth-child(1)': {
      order: 0,
    },
    '&:nth-child(2)': {
      order: 2,
    },
    '&:nth-child(3)': {
      order: 1,
      marginLeft: '54px',
    },
    '&:nth-child(4)': {
      order: 3,
      marginLeft: '54px',
    },
  },
}));
